import { LoadScript } from "@react-google-maps/api";
import React from "react";

import { useNetworkStatus } from "../../contexts/network.context";
import { isEnv } from "../../utils/helpers";

const libraries = ["places"];

const GoogleMapLoader: React.FunctionComponent = ({ children }) => {
  const networkStatus = useNetworkStatus();
  if (!isEnv("production") && networkStatus === "offline") {
    return <>{children}</>;
  }
  // use env key
  return (
    <LoadScript
      libraries={libraries}
      id="script-loader"
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
    >
      {children}
    </LoadScript>
  );
};

export default GoogleMapLoader;
